module.exports = __webpack_public_path__ + "img/team_jordon.dfe94eff.jpg";